import { range, sample } from 'lodash-es'
import { charset, PasswordCharacterSetMap } from 'src/constants/dict'
import { PasswordCharacterSet } from 'src/generated/apollo'
import { useIntl } from '@frontend/t7nd'

export const PasswordMessages = {
  LENGTH: {
    id: '{length}位',
    defaultMessage: '{length}位',
  },
  CHARACTER_SET_HINT: {
    id: '必须包括{sets}',
    defaultMessage: '必须包括{sets}',
  },
  PASSWORD_HINT: {
    id: '请输入不少于{length}的密码。{characterSetHint}',
    defaultMessage: '请输入不少于{length}的密码。{characterSetHint}',
  },
  PASSWORD_INFO: {
    id: '{hint}\n特殊符号包括：~ ! @ # $ % ^ & * ( ) _ + - = , .',
    defaultMessage: '{hint}\n特殊符号包括：~ ! @ # $ % ^ & * ( ) _ + - = , .',
  },
} as const

type CustomPasswordFieldProps = {
  length: number
  characterSet?: PasswordCharacterSet[]
}

export function CreateCustomPasswordInfo({
  length,
  characterSet,
}: CustomPasswordFieldProps) {
  const { formatMessage } = useIntl()

  const lengthText = length
    ? formatMessage(PasswordMessages.LENGTH, { length })
    : ''

  const characterSetHint = characterSet?.length
    ? formatMessage(PasswordMessages.CHARACTER_SET_HINT, {
        sets: (Object.keys(PasswordCharacterSetMap) as PasswordCharacterSet[])
          .filter((set) => characterSet.includes(set))
          .map((item) => PasswordCharacterSetMap({ formatMessage })[item])
          .join('/'),
      })
    : ''

  const hint = formatMessage(PasswordMessages.PASSWORD_HINT, {
    length: lengthText,
    characterSetHint,
  })

  return {
    info: formatMessage(PasswordMessages.PASSWORD_INFO, { hint }),
  }
}

export function generateCustomPassword({
  length,
  characterSet,
}: CustomPasswordFieldProps) {
  const requiredPassword = (characterSet || []).map((set) =>
    sample(charset[set]),
  )
  const restPassword = range(0, length - requiredPassword.length).map(() =>
    sample(sample(Object.values(charset))),
  )
  const result = requiredPassword
    .concat(restPassword)
    .sort(() => 0.5 - Math.random())
    .join('')

  return result
}

export function isCustomPasswordValid(
  password: string,
  { length, characterSet }: CustomPasswordFieldProps,
) {
  if (password.length === 0) return false
  if (password.length < length) return false
  if (!/^[\w~!@#$%^&*()_+\-=,.]{1,1000}$/.test(password)) {
    return false
  }
  return (characterSet || [])
    .map((item) => {
      return Array.from(charset[item]).some((char) => password.includes(char))
    })
    .every(Boolean)
}
